/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { createSelector } from "reselect";
import { getDataSourceObj, getListViewObj } from "./helper";
import { getCurrentDatapipe } from "../datapipe/selector";
import { _d } from "../../app-old/utilities/utils";

export const getPlayer = (state) => state.player;
export const getPlayers = createSelector(
  [getPlayer],
  (players) => players.list,
);
export const getPlayerForList = createSelector([getPlayer], (players) =>
  players && players.list
    ? players.list.map((player) => getListViewObj(player))
    : [],
);
export const getPlayerListForDataSource = createSelector(
  [getPlayer],
  (players) =>
    players && players.list
      ? players.list.map(
          /* istanbul ignore next */ (player) => getDataSourceObj(player),
        )
      : [],
);
export const getPlayersLoadingState = createSelector(
  [getPlayer],
  (players) => ({
    loading: players && players.loading,
    loaded: players && players.loaded,
  }),
);
export const getDataPipePlayerIds = createSelector(
  [getCurrentDatapipe, getPlayer],
  /* istanbul ignore next */ (currentDatapipe) => {
    let playerIds = _d.pluck(currentDatapipe.collectorConfigs, "collectorId");
    const setIds = new Set(playerIds);
    playerIds = [...setIds];
    return playerIds;
  },
);
export const getDataPipePlayerIdsV2 = createSelector(
  [getCurrentDatapipe, getPlayer],
  /* istanbul ignore next */ (currentDatapipe) => {
    let playerIds = _d.pluck(currentDatapipe.collectorConfigs, "configId");
    const setIds = new Set(playerIds);
    playerIds = [...setIds];
    return playerIds;
  },
);
export const getPlayerEntities = createSelector(
  [getPlayer],
  /* istanbul ignore next */ (players) =>
    players?.entities ? players.entities : undefined,
);
export const getPlayerCompany = createSelector(
  [getPlayer],
  (players) => players.selectedCompanyForPlayer,
);
export const getDataPipePlayers = createSelector(
  [getDataPipePlayerIds, getPlayer],
  /* istanbul ignore next */ (playerIds, player) => {
    const players = [];
    playerIds.forEach((playerId) => {
      const eachPlayer = player.entities ? player.entities[playerId] : null;
      if (eachPlayer) {
        players.push(eachPlayer);
      }
    });
    return players;
  },
);
export const getDataPipePlayersV2 = createSelector(
  [getDataPipePlayerIdsV2, getPlayer],
  /* istanbul ignore next */ (playerIds, player) => {
    const players = [];
    playerIds.forEach((playerId) => {
      const eachPlayer = player.entities ? player.entities[playerId] : null;
      if (eachPlayer) {
        players.push(eachPlayer);
      }
    });
    return players;
  },
);

export const getPlayerRestrictionList = createSelector(
  [getPlayer],
  (players) => players?.playerRestrictionList,
);
export const getPlayerRestrictionSuccessResponse = createSelector(
  [getPlayer],
  (players) => players?.successResponse,
);
